module.exports = "<div class=\"col-xs-4\">\n    <div class=\"dz-preview dz-file-preview thumbnail\">\n        <div class=\"dz-details\">\n            <img data-dz-thumbnail />\n            <div class=\"dz-filename caption\">\n                <p data-dz-name></p>\n                <p class=\"dz-size\" data-dz-size></p>\n            </div>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/fileDialog/templates/dropzone.html
// module id = 1193
// module chunks = 0